module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic05.e043abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic05.png
// module id = 470
// module chunks = 1